import { useCallback } from 'react';
import { doGet, doPatch } from 'hooks/requests';
import { useAxios } from '../../hooks/useAxios';

export const useCoreService = () => {
    const { get, patch, isLoading } = useAxios();

    const getIndustries = useCallback(() => doGet('/core/industry/'), []);

    const getCustomerChartsOfAccountsForEdit = useCallback(
        (accountId, companyId, nonAccountantMode) =>
            get(
                nonAccountantMode
                    ? `/core/customer_chart_of_accounts/get_accounts_for_edit/?company_id=${companyId}&current_account=${accountId}&non_accountant_mode=${nonAccountantMode}`
                    : `/core/customer_chart_of_accounts/get_accounts_for_edit/?company_id=${companyId}&non_accountant_mode=${nonAccountantMode}`,
            ),
        [get],
    );

    const getTransactionStatusOptions = useCallback(
        (companyId, nonAccountantMode) =>
            get(
                `/core/customer_chart_of_accounts/get_accounts_for_edit/?company_id=${companyId}&non_accountant_mode=${nonAccountantMode}`,
            ),
        [get],
    );

    const getListOfParentsAccounts = useCallback(
        (companyId) => doGet(`/core/customer-chart-of-accounts/${companyId}/list_parent_accounts/`),
        [],
    );

    const getCoaAccount = useCallback(
        (accountId) => doGet(`/core/customer-chart-of-account/${accountId}/`),
        [],
    );

    const getActiveAccounts = useCallback(
        (companyId, pageNumber) =>
            doGet(`/core/customer_chart_of_accounts/${companyId}/active?page=${pageNumber}`),
        [],
    );

    const getInActiveAccounts = useCallback(
        (companyId, pageNumber) =>
            doGet(`/core/customer_chart_of_accounts/${companyId}/inactive?page=${pageNumber}`),
        [],
    );

    const updateAccount = (customerId, companyId, data) =>
        doPatch(`/core/customer-chart-of-accounts/${companyId}/update-note/${customerId}/`, data);

    const getCurrencyCodes = useCallback(() => doGet(`/core/currencies/codes/`), []);

  

    return {
        isLoading,
        getCoaAccount,
        getIndustries,
        updateAccount,
        getCurrencyCodes,
        getActiveAccounts,
        getInActiveAccounts,
        getListOfParentsAccounts,
        getTransactionStatusOptions,
        getCustomerChartsOfAccountsForEdit,
    };
};
